import React from "react";
import GenericTable from "../../GenericTable";

/* ---------------------------- Domains Table ---------------------------- */
export const Domains = () => {
  const visibleColumns = [
    { key: "domain_name", label: "Name" },
    { key: "domain_enabled", label: "Enabled" },
    { key: "domain_description", label: "Description" },
  ];

  const booleanColumns = ["domain_enabled"];

  return (
    <GenericTable
      tableName="v_domains"
      title="Domains"
      parentName="HUCS"
      addRoute="/admin/hucs/add/v_domains"
      editBaseRoute="/admin/hucs/edit"
      rowKey="domain_uuid"
      visibleColumns={visibleColumns}
      booleanColumns={booleanColumns}
    />
  );
};

/* ---------------------- Default Settings Table ---------------------- */
export const DomainSettings = () => {
  const visibleColumns = [
    { key: "domain_setting_subcategory", label: "Subcategory" },
    { key: "domain_setting_name", label: "Type" },
    { key: "domain_setting_value", label: "Value" },
    { key: "domain_setting_enabled", label: "Enabled" },
    { key: "domain_setting_description", label: "Description" },
  ];

  const booleanColumns = ["domain_setting_enabled"];

  return (
    <GenericTable
      tableName="v_domain_settings"
      title="Domain Settings"
      parentName="HUCS"
      addRoute="/admin/hucs/add/v_domain_settings"
      editBaseRoute="/admin/hucs/edit"
      rowKey="domain_setting_uuid"
      visibleColumns={visibleColumns}
      booleanColumns={booleanColumns}
    />
  );
};

export const DefaultSettings = () => {
  const visibleColumns = [
    { key: "default_setting_subcategory", label: "Subcategory" },
    { key: "default_setting_name", label: "Type" },
    { key: "default_setting_value", label: "Value" },
    { key: "default_setting_enabled", label: "Enabled" },
    { key: "default_setting_description", label: "Description" },
  ];

  const booleanColumns = ["default_setting_enabled"];

  const SECTIONS = [
    { label: "Active Calls", value: "active_calls" },
    { label: "Authentication", value: "authentication" },
    { label: "Bridge", value: "bridge" },
    { label: "Cache", value: "cache" },
    { label: "Call Block", value: "call_block" },
    { label: "Call Center", value: "call_center" },
    { label: "Call Flow", value: "call_flow" },
    { label: "Call Recordings", value: "call_recordings" },
    { label: "CDR", value: "cdr" },
    { label: "Conference", value: "conference" },
    { label: "Conference Center", value: "conference_center" },
    { label: "Contact", value: "contact" },
    { label: "Dashboard", value: "dashboard" },
    { label: "Database Transactions", value: "database_transactions" },
    { label: "Destinations", value: "destinations" },
    { label: "Devices", value: "devices" },
    { label: "Dialplan", value: "dialplan" },
    { label: "Domain", value: "domain" },
    { label: "Editor", value: "editor" },
    { label: "Email", value: "email" },
    { label: "Email Queue", value: "email_queue" },
    { label: "Emergency", value: "emergency" },
    { label: "Extension", value: "extension" },
    { label: "Fax", value: "fax" },
    { label: "Fax Queue", value: "fax_queue" },
    { label: "Follow Me", value: "follow_me" },
    { label: "IVR Menu", value: "ivr_menu" },
    { label: "Limit", value: "limit" },
    { label: "Log", value: "log" },
    { label: "Login", value: "login" },
    { label: "Message", value: "message" },
    { label: "Menu", value: "menu" },
    { label: "Operator Panel", value: "operator_panel" },
    { label: "Provision", value: "provision" },
    { label: "Recordings", value: "recordings" },
    { label: "Registrations", value: "registrations" },
    { label: "Ring Group", value: "ring_group" },
    { label: "Server", value: "server" },
    { label: "Session", value: "session" },
    { label: "Speech", value: "speech" },
    { label: "Switch", value: "switch" },
    { label: "Theme", value: "theme" },
    { label: "Time Conditions", value: "time_conditions" },
    { label: "Transcribe", value: "transcribe" },
    { label: "Users", value: "users" },
    { label: "Voicemail", value: "voicemail" },
  ];

  return (
    <GenericTable
      tableName="v_default_settings"
      title="Default Settings"
      parentName="HUCS"
      addRoute="/admin/hucs/add/v_default_settings"
      editBaseRoute="/admin/hucs/edit"
      rowKey="default_setting_uuid"
      visibleColumns={visibleColumns}
      booleanColumns={booleanColumns}
      groupBy="default_setting_category"
      sections={SECTIONS}
    />
  );
};

export const Variables = () => {
  const visibleColumns = [
    { key: "var_name", label: "Name" },
    { key: "var_value", label: "Value" },
    { key: "var_hostname", label: "Hostname" },
    { key: "var_enabled", label: "Enabled" },
    { key: "var_description", label: "Description" },
  ];

  const booleanColumns = ["var_enabled"];

  const SECTIONS = [
    { label: "Codecs", value: "Codecs" },
    { label: "Defaults", value: "Defaults" },
    { label: "IP Address", value: "IP Address" },
    { label: "Music on Hold", value: "Music on Hold" },
    { label: "Ringtones", value: "Ringtones" },
    { label: "Security", value: "Security" },
    { label: "SIP", value: "SIP" },
    { label: "SIP Profile: External", value: "SIP Profile: External" },
    { label: "SIP Profile: Internal", value: "SIP Profile: Internal" },
    { label: "Sound", value: "Sound" },
    { label: "Tones", value: "Tones" },
    { label: "XMPP", value: "XMPP" },
  ];

  return (
    <GenericTable
      tableName="v_vars"
      title="Variables"
      singularTitle="Variable"
      parentName="HUCS"
      addRoute="/admin/hucs/add/v_vars"
      editBaseRoute="/admin/hucs/edit"
      rowKey="var_uuid"
      visibleColumns={visibleColumns}
      booleanColumns={booleanColumns}
      groupBy="var_category"
      sections={SECTIONS}
    />
  );
};

export const SipProfiles = () => {
  const visibleColumns = [
    { key: "sip_profile_name", label: "Name" },
    { key: "sip_profile_hostname", label: "Hostname" },
    { key: "sip_profile_enabled", label: "Enabled" },
    { key: "sip_profile_description", label: "Description" },
  ];

  const booleanColumns = ["sip_profile_enabled"];

  return (
    <GenericTable
      tableName="v_sip_profiles"
      title="SIP Profiles"
      parentName="HUCS"
      addRoute="/admin/hucs/add/sip-profile"
      editBaseRoute={(row) => `/admin/hucs/edit/sip-profile/${row.sip_profile_uuid}`}
      rowKey="sip_profile_uuid"
      visibleColumns={visibleColumns}
      booleanColumns={booleanColumns}
    />
  );
};

export const SofiaGlobalSettings = () => {
  const visibleColumns = [
    { key: "global_setting_name", label: "Name" },
    { key: "global_setting_value", label: "Value" },
    { key: "global_setting_enabled", label: "Enabled" },
    { key: "global_setting_description", label: "Description" },
  ];

  const booleanColumns = ["global_setting_enabled"];

  return (
    <GenericTable
      tableName="v_sofia_global_settings"
      title="Sofia Global Settings"
      parentName="HUCS"
      addRoute="/admin/hucs/add/v_sofia_global_settings"
      editBaseRoute="/admin/hucs/edit"
      rowKey="sofia_global_setting_uuid"
      visibleColumns={visibleColumns}
      booleanColumns={booleanColumns}
    />
  );
};

/* ---------------------- Modules Table ---------------------- */
export const Modules = () => {
  const visibleColumns = [
    { key: "module_label", label: "Label" },
    { key: "module_status", label: "Status" },
    { key: "module_action", label: "Action" },
    { key: "module_enabled", label: "Enabled" },
    { key: "module_description", label: "Description" },
  ];

  const booleanColumns = ["module_enabled"];

  const SECTIONS = [
    { label: "Applications", value: "Applications" },
    { label: "Codecs", value: "Codecs" },
    { label: "Databases", value: "Databases" },
    { label: "Dialplan Interfaces", value: "Dialplan Interfaces" },
    { label: "Endpoints", value: "Endpoints" },
    { label: "Event Handlers", value: "Event Handlers" },
    { label: "File Format Interfaces", value: "File Format Interfaces" },
    { label: "Formats", value: "Formats" },
    { label: "Languages", value: "Languages" },
    { label: "Loggers", value: "Loggers" },
    { label: "Say", value: "Say" },
    { label: "Streams / Files", value: "Streams / Files" },
    { label: "XML Interfaces", value: "XML Interfaces" },
  ];

  return (
    <GenericTable
      tableName="v_modules"
      title="Modules"
      parentName="HUCS"
      addRoute="/admin/hucs/add/v_modules"
      editBaseRoute="/admin/hucs/edit"
      rowKey="module_uuid"
      visibleColumns={visibleColumns}
      booleanColumns={booleanColumns}
      groupBy="module_category"
      sections={SECTIONS}
    />
  );
};

/* ---------------------- Access Controls Table ---------------------- */
export const AccessControls = () => {
  const visibleColumns = [
    { key: "access_control_name", label: "Name" },
    { key: "access_control_default", label: "Default" },
    { key: "access_control_description", label: "Description" },
  ];

  const booleanColumns = ["access_control_default"];

  return (
    <GenericTable
      tableName="v_access_controls"
      title="Access Controls"
      parentName="HUCS"
      addRoute="/admin/hucs/add/access-control"
      editBaseRoute={(row) => `/admin/hucs/edit/access-control/${row.access_control_uuid}`}
      rowKey="access_control_uuid"
      visibleColumns={visibleColumns}
      booleanColumns={booleanColumns}
    />
  );
};

/* ---------------------- Email Templates Table ---------------------- */
export const EmailTemplates = () => {
  const visibleColumns = [
    { key: "template_category", label: "Category" },
    { key: "template_subcategory", label: "Subcategory" },
    { key: "template_subject", label: "Subject" },
    { key: "template_type", label: "Type" },
    { key: "template_enabled", label: "Enabled" },
    { key: "template_description", label: "Description" },
  ];

  const booleanColumns = ["template_enabled"];

  return (
    <GenericTable
      tableName="v_email_templates"
      title="Email Templates"
      parentName="HUCS"
      addRoute="/admin/hucs/add/email-template"
      editBaseRoute={(row) => `/admin/hucs/edit/email-template/${row.email_template_uuid}`}
      rowKey="email_template_uuid"
      visibleColumns={visibleColumns}
      booleanColumns={booleanColumns}
    />
  );
};

/* ---------------------- Databases Table ---------------------- */
export const Databases = () => {
  const visibleColumns = [
    { key: "database_driver", label: "Driver" },
    { key: "database_type", label: "Type" },
    { key: "database_host", label: "Host" },
    { key: "database_name", label: "Name" },
    { key: "database_description", label: "Description" },
  ];

  return (
    <GenericTable
      tableName="v_databases"
      title="Databases"
      parentName="HUCS"
      addRoute="/admin/hucs/add/v_databases"
      editBaseRoute="/admin/hucs/edit"
      rowKey="database_uuid"
      visibleColumns={visibleColumns}
    />
  );
};

/* ---------------------- Number Translations Table ---------------------- */
export const NumberTranslations = () => {
  const visibleColumns = [
    { key: "number_translation_name", label: "Name" },
    { key: "number_translation_enabled", label: "Enabled" },
    { key: "number_translation_description", label: "Description" },
  ];

  const booleanColumns = ["number_translation_enabled"];

  return (
    <GenericTable
      tableName="v_number_translations"
      title="Number Translations"
      parentName="HUCS"
      addRoute="/admin/hucs/add/number-translation"
      editBaseRoute={(row) =>
        `/admin/hucs/edit/number-translation/${row.number_translation_uuid}`
      }
      rowKey="number_translation_uuid"
      visibleColumns={visibleColumns}
      booleanColumns={booleanColumns}
    />
  );
};

export default { Domains, DomainSettings, DefaultSettings, Variables, SipProfiles, SofiaGlobalSettings, Modules, AccessControls, EmailTemplates, Databases, NumberTranslations };